import PropTypes from 'prop-types';
import React from 'react';

const MainContent = ({ disableStyles = false, children, className }) => (
  <div className={!disableStyles && className}>{children}</div>
);

MainContent.propTypes = {
  children: PropTypes.any,
  disableStyles: PropTypes.bool,
};

export default MainContent;
